import { UserEmailConstants } from './user-email-constants';

export const EMAIL_IS_EMG_APPS = (email: string | undefined): boolean => {
  const is: boolean =
    email?.endsWith(UserEmailConstants.EMGAPPS_AI) ||
    email?.endsWith(UserEmailConstants.SYMPHIQ_COM) ||
    email === UserEmailConstants.ERIC_STEPHEN_MAAS_GMAIL ||
    email === UserEmailConstants.JEREMYRGUNN_GMAIL ||
    email === UserEmailConstants.JON_R_OLER_GMAIL ||
    email === UserEmailConstants.JON_R_OLER_2_GMAIL ||
    email === UserEmailConstants.BJORN_ESPENES_GMAIL;
  return is;
}
export const EMAIL_IS_EMG_APPS_CROSS_ACCOUNTS_ENABLED = (email: string | undefined): boolean => {
  const is: boolean = EMAIL_IS_EMG_APPS(email);
  return is;
}
export const EMAIL_IS_DEV = (email: string | undefined): boolean => {
  const is: boolean = email === UserEmailConstants.ERIC_STEPHEN_MAAS_GMAIL ||
    email === UserEmailConstants.JON_R_OLER_GMAIL ||
    email === UserEmailConstants.ERIC_EMGAPPS_AI ||
    email === UserEmailConstants.ERIC_SYMPHIQ_COM
  ;
  return is;
}
